import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const text = css({
  margin: 0,
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});
